<script setup="">
import { computed } from "vue";

import { useColor } from "@/composables/color";
import { useScrollStore } from "@/stores/scroll";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  isLoggedIn: {
    type: Boolean,
    required: true
  },
  backgroundColor: {
    type: String,
    required: true
  }
});

const color = useColor();
const scroll = useScrollStore();

const hasUtmValue = computed(() => props.campaign.settings.utm_source || props.campaign.settings.utm_medium);
const isLightColorPrimary = computed(() => color.isLightColor(props.campaign.settings.primary_color));

const getLink = (link) => {
  if (link.type === "link") {
    if (hasUtmValue.value) {
      return `${link}?utm_source=${props.campaign.settings.utm_source}&utm_medium=${props.campaign.settings.utm_medium}`;
    }
    return link.value;
  }

  return `tel:${link.value}`;
};
</script>

<template>
  <div
    class="fixed inset-x-0 z-20 mx-auto h-16 w-full max-w-campaign transform-gpu items-center transition duration-500 isp-bottom-6 sm:pl-[var(--primary-sidebar-min-width)] lg:inset-x-auto xl:pl-0"
    :class="{ hidden: scroll.isAtBottom }"
    data-role="nav"
  >
    <a class="block px-4" :href="getLink(campaign.settings.action)" :target="campaign.settings.action.target">
      <div
        class="flex-center h-14 animate-bounce-slow rounded-full bg-campaign-primary text-center shadow-xl hover:animate-none"
        :class="[isLightColorPrimary ? 'text-black' : 'text-white']"
      >
        <div>
          <p class="text-sm">{{ campaign.settings.action.tagline }}</p>
          <h1 class="-mt-0.5 text-lg font-bold tracking-tight md:text-xl">{{ campaign.settings.action.title }}</h1>
        </div>
      </div>
    </a>
  </div>
</template>
